module.exports = __webpack_public_path__ + "images/花筑般蓝pr长图10-4.jpg?v=8f025e55";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr长图10-4.jpg
 ** module id = 57
 ** module chunks = 1 2
 **/